"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            animation: ", " ", "ms linear;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            animation: ", " ", "ms linear;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        from {\n            transform: translateX(-100%);\n        }\n        \n        to {\n            transform: translateX(0);\n        }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        from {\n            transform: translateX(0);\n        }\n    \n        to {\n            transform: translateX(-100%);\n        }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var toLeft = (0, _styledComponents.keyframes)(_templateObject()),
    toRight = (0, _styledComponents.keyframes)(_templateObject2());

function _default(theme, props) {
  var palette = theme.palette,
      navigationWrapper = {
    position: 'absolute',
    transform: theme.navigationTransform,
    background: theme.navigationBackground,
    zIndex: theme.navigationZIndex,
    borderRadius: theme.navigationBorderRadius,
    width: theme.navigationWidth + 'px',
    height: theme.navigationHeight + 'px',
    cursor: 'pointer',
    transitionProperty: 'background, border-radius, transform',
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    '&:hover': {
      background: theme.hoverNavigationBackground
    }
  },
      navigationImg = {
    width: '100%',
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  },
      bullet = {
    borderRadius: '50%',
    background: theme.bulletBackground,
    cursor: 'pointer',
    margin: theme.bulletMargin,
    width: theme.bulletWidth,
    height: theme.bulletHeight,
    display: 'inline-block',
    transitionProperty: 'background',
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    '&:not(:last-child)': {
      margin: theme.bulletMargin
    }
  };
  return {
    root: {
      width: '100%',
      background: theme.background,
      padding: theme.padding,
      display: 'flex',
      flexDirection: 'column'
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      position: 'relative'
    },
    navigationRight: _objectSpread({}, navigationWrapper, {
      top: theme.navigationBackPositionTop,
      right: theme.navigationNextPositionRight
    }),
    navigationLeft: _objectSpread({}, navigationWrapper, {
      top: theme.navigationNextPositionTop,
      left: theme.navigationBackPositionLeft
    }),
    navigationImgLeft: _objectSpread({}, navigationImg, {
      backgroundImage: "url(\"".concat(theme.navigationBackIcon, "\")")
    }),
    navigationImgRight: _objectSpread({}, navigationImg, {
      backgroundImage: "url(\"".concat(theme.navigationNextIcon, "\")")
    }),
    wrapper: {
      width: '100%',
      margin: '0 auto',
      overflow: 'hidden',
      display: 'flex'
    },
    slideWrapper: {
      height: '100%',
      width: '100%',
      minWidth: '100%',
      overflow: 'hidden'
    },
    animationToRight: (0, _styledComponents.css)(_templateObject3(), toRight, props.timeout),
    animationToLeft: (0, _styledComponents.css)(_templateObject4(), toLeft, props.timeout),
    bulletWrapper: {
      padding: "".concat(palette.gutter, "px 0"),
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    bullet: bullet,
    bulletActive: _objectSpread({}, bullet, {
      cursor: 'default',
      background: theme.activeBulletBackground
    }),
    counter: {
      position: 'absolute',
      bottom: theme.counterPositionBottom,
      right: theme.counterPositionRight,
      color: theme.counterColor,
      padding: theme.counterPadding,
      borderRadius: theme.counterBorderRadius,
      whiteSpace: 'nowrap',
      background: theme.counterBackground,
      fontSize: theme.counterFontSize,
      lineHeight: theme.counterLineHeight,
      textShadow: theme.counterTextShadow
    }
  };
}